// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"Footer_pageFooter__K1NTk","legalLinkContainer":"Footer_legalLinkContainer__OcZO3","legalLink":"Footer_legalLink__PvCqj"};